export class AppConstants {
  static baseUrl = process.env.REACT_APP_BASE_URL;
}
